import React from "react";
import ContentLoader from "react-content-loader";

const LoaderHeader = (props) => {
  return (
    <ContentLoader viewBox="0 0 1500 40" width="100%" height={40} {...props}>
      <rect x="0" y="8" rx="6" ry="6" width="100%" height="24" />
    </ContentLoader>
  );
};

export default LoaderHeader;
